import { render, staticRenderFns } from "./FirstInit.vue?vue&type=template&id=02cc5030&scoped=true"
import script from "./FirstInit.vue?vue&type=script&lang=js"
export * from "./FirstInit.vue?vue&type=script&lang=js"
import style0 from "./FirstInit.vue?vue&type=style&index=0&id=02cc5030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cc5030",
  null
  
)

export default component.exports